export default {
  data: function() {
    return {
      submitLoading: false
    }
  },
  computed: {
    isFormDirty() {
      return Object.keys(this.fields).some(key => this.fields[key].dirty)
    },
    isTouched() {
      return Object.keys(this.fields).some(key => this.fields[key].touched)
    },
    isFormValid() {
      return (
        Object.keys(this.fields).filter(key => this.fields[key].invalid)
          .length === 0
      )
    },
  },
  watch: {
    formData: {
      handler: function(val) {
        console.log(this.formData, this.isTouched, this.isFormDirty, this.isFormValid, this.$validator)
        if (this.isFormValid) {
          this.$emit('change', this.formData)
        }
      },
      deep: true
    }
  },
  methods: {
    /* submit the form with the promise return from getFormSubmitPromise
     * Automatically add form errors to corresponding fields*/
    submit: function() {
      if (!this.isFormValid) return
      const vm = this
      vm.submitLoading = true
      this.getFormSubmitPromise()
        .then(function(res) {
          vm.setPristine()
        })
        .catch(function(errors) {
          errors && 
            errors.forEach(function(e) {
              vm.addFormError(e.field, e.msg)
            })
        })
        .then(function() {
          vm.submitLoading = false
        })
    },
    addFormError(field_name, error) {
      console.log('adding error')
      const field = this.$validator.fields.find({
        name: field_name,
        scope: this.$options.scope
      })
      if (!field) return

      this.$validator.errors.add({
        id: field.id,
        field: field_name,
        msg: error,
        scope: this.$options.scope
      })

      field.setFlags({
        invalid: true,
        valid: false,
        validated: true
      })
    },
    setPristine(){
      return Object.keys(this.fields).map(key => this.fields[key].touched = false)
    }
  }
}
